import React, { useState } from 'react';
import { View, Text } from 'react-native';
import { useMutation } from '@apollo/client';
import styled from 'styled-components';
import { MentionsInput, Mention } from 'react-mentions';

import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { mentionHighlight } from 'app/src/styles/colors';

import { CREATE_NOTIFICATION } from './queries';

const Body = styled(MentionsInput)`
  font-family: sans-serif;
  height: 6em;
`;

const mentionInputStyle = {
  suggestions: {
    list: {
      border: '1px solid black',
      padding: '6px',
    }
  }
}

const NewNotification = ({ resource, field, refetch, users }) => {
  const [body, setBody] = useState('');

  const [createNotification] = useMutation(CREATE_NOTIFICATION, {
    onCompleted: () => {
      refetch();
      setBody('');
    }
  });

  const handleSubmit = () => {
    createNotification({
      variables: {
        resourceType: resource.__typename,
        resourceId: resource.id,
        field,
        body,
      }
    });
  };

  const userOptions = users.map(user => ({
    id: user.id,
    display: `@${user.name} (${user.organization})`,
  }));

  return (
    <View>
      <Body
        placeholder="New Message"
        value={body}
        onChange={e => setBody(e.target.value)}
        allowSpaceInQuery
        style={mentionInputStyle}
      >
        <Mention
          trigger="@"
          data={userOptions}
          markup="@[__display__]{__id__}"
          style={{backgroundColor: mentionHighlight}}
        />
      </Body>

      <ButtonGroup>
        <Button label="Send" onPress={handleSubmit} />
      </ButtonGroup>
    </View>
  );
};

export default NewNotification;
